var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ScrollSelect", {
    attrs: {
      api: _vm.api,
      placeholder: _vm.placeholder || _vm.$t("chooseText"),
      multiple: _vm.multiple,
      disabled: _vm.disabled,
      size: _vm.size,
      "collapse-tags": _vm.collapseTags,
      remote: _vm.remote,
      "default-params": _vm.defaultParams,
      "default-options": _vm.defaultOptions,
      "page-size": 99,
      "search-key": "name",
      "option-label": "name",
      "option-value": _vm.optionValue,
      "res-key": "content",
    },
    on: { change: _vm.onChange },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v
      },
      expression: "id",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }